import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { class: "text-primary mb-6" }, "Datos del representante", -1)
const _hoisted_3 = { class: "col-sm-12" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", { class: "fw-bold text-dark" }, "País", -1)
const _hoisted_5 = { class: "col-sm-6" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { class: "fw-bold text-dark" }, "Tipo de documento", -1)
const _hoisted_7 = { class: "col-sm-6" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", { class: "fw-bold text-dark" }, "Número de documento", -1)
const _hoisted_9 = { class: "col-sm-12" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", { class: "fw-bold text-dark" }, "Nombres completos", -1)
const _hoisted_11 = { class: "col-sm-6" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { class: "fw-bold text-dark" }, "Primer apellidos", -1)
const _hoisted_13 = { class: "col-sm-6" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { class: "fw-bold text-dark" }, "Segundo apellido", -1)
const _hoisted_15 = { class: "col-sm-6" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", { class: "fw-bold text-dark" }, "Sexo", -1)
const _hoisted_17 = { class: "col-sm-6" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", { class: "fw-bold text-dark" }, "Fecha de nacimiento", -1)
const _hoisted_19 = { class: "col-sm-4" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", { class: "fw-bold text-dark" }, "Celular", -1)
const _hoisted_21 = { class: "col-sm-8" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("label", { class: "fw-bold text-dark" }, "Correo electrónico", -1)

import { onMounted } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'StepRepman',
  props: {
    form: null,
    listCountries: null
  },
  setup(__props: any) {

const props = __props as {
    form: any;
    listCountries: any;
};




//const regex = new RegExp("^[0-9]{0,8}$"); 

function applyMask(value: string, mask: string): string {
  let i = 0;
  return mask.replace(/#/g, () => value[i++] ?? "");
}

const onInputDocument = (val: string) =>{
    const regex = new RegExp(props.form.idcountry2.regex);
  const mask  = props.form.idcountry2.mask;

  // 1. Mantener solo caracteres permitidos por el REGEX (ej: solo dígitos)
  const allowedChars = val.replace(/[^0-9A-Za-z]/g, ""); 

  // 2. Si no cumple el regex parcial, recortar
  if (!regex.test(allowedChars)) {
    // elimina el último carácter inválido
    val = allowedChars.slice(0, -1);
  } else {
    val = allowedChars;
  }

  // 3. Aplicar la máscara dinámica
  const applyMask = (value: string, mask: string): string => {
    let i = 0;
    return mask.replace(/#/g, () => value[i++] ?? "");
  };

  const maskedValue = applyMask(val, mask);

  // 4. Actualizar modelo
  props.form.docnumber = maskedValue;
};

onMounted(()=>{
    /*console.log(props.form.birthday)
    if(props.form.birthday === ''){
        props.form.birthday = '1990-01-01'
    }
    */
});

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_el_form_item, {
        prop: "idcountry2",
        rules: [
                {required: true, message:'Campo obligatorio', trigger:['blur', 'change']}
            ]
      }, {
        label: _withCtx(() => [
          _hoisted_4
        ]),
        default: _withCtx(() => [
          _createVNode(_component_el_select, {
            modelValue: __props.form.idcountry2,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((__props.form.idcountry2) = $event)),
            filterable: "",
            "value-key": "idcountry"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.listCountries, (item, index) => {
                return (_openBlock(), _createBlock(_component_el_option, {
                  label: item?.name,
                  value: item,
                  key: `lst-cou-${index}`
                }, null, 8, ["label", "value"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_el_form_item, {
        prop: "doctype",
        rules: [
                {required: true, message:'Campo obligatorio', trigger:['blur', 'change']}
            ]
      }, {
        label: _withCtx(() => [
          _hoisted_6
        ]),
        default: _withCtx(() => [
          _createVNode(_component_el_select, {
            modelValue: __props.form.doctype,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((__props.form.doctype) = $event))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_option, {
                label: "DNI",
                value: "1"
              })
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(_component_el_form_item, {
        prop: "docnumber",
        rules: [
                {required: true, message:'Campo obligatorio', trigger:['blur', 'change']}
            ]
      }, {
        label: _withCtx(() => [
          _hoisted_8
        ]),
        default: _withCtx(() => [
          _createVNode(_component_el_input, {
            modelValue: __props.form.docnumber,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((__props.form.docnumber) = $event)),
            onInput: onInputDocument
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createVNode(_component_el_form_item, {
        prop: "firstname",
        rules: [
                {required: true, message:'Campo obligatorio', trigger:['blur', 'change']}
            ]
      }, {
        label: _withCtx(() => [
          _hoisted_10
        ]),
        default: _withCtx(() => [
          _createVNode(_component_el_input, {
            modelValue: __props.form.firstname,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((__props.form.firstname) = $event)),
            maxlength: "30"
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createVNode(_component_el_form_item, {
        prop: "lastname",
        rules: [
                {required: true, message:'Campo obligatorio', trigger:['blur', 'change']}
            ]
      }, {
        label: _withCtx(() => [
          _hoisted_12
        ]),
        default: _withCtx(() => [
          _createVNode(_component_el_input, {
            modelValue: __props.form.lastname,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((__props.form.lastname) = $event)),
            maxlength: "30"
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createVNode(_component_el_form_item, {
        prop: "surname",
        rules: [
                {required: true, message:'Campo obligatorio', trigger:['blur', 'change']}
            ]
      }, {
        label: _withCtx(() => [
          _hoisted_14
        ]),
        default: _withCtx(() => [
          _createVNode(_component_el_input, {
            modelValue: __props.form.surname,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((__props.form.surname) = $event)),
            maxlength: "30"
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_15, [
      _createVNode(_component_el_form_item, {
        prop: "gender",
        rules: [
                {required: true, message:'Campo obligatorio', trigger:['blur', 'change']}
            ]
      }, {
        label: _withCtx(() => [
          _hoisted_16
        ]),
        default: _withCtx(() => [
          _createVNode(_component_el_select, {
            modelValue: __props.form.gender,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((__props.form.gender) = $event))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_option, {
                label: "Masculino",
                value: "M"
              }),
              _createVNode(_component_el_option, {
                label: "Femenino",
                value: "F"
              })
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_17, [
      _createVNode(_component_el_form_item, {
        prop: "birthday",
        rules: [
                {required: true, message:'Campo obligatorio', trigger:['blur', 'change']}
            ]
      }, {
        label: _withCtx(() => [
          _hoisted_18
        ]),
        default: _withCtx(() => [
          _createVNode(_component_el_date_picker, {
            modelValue: __props.form.birthday,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((__props.form.birthday) = $event)),
            type: "date",
            format: "DD/MM/YYYY",
            "value-format": "YYYY-MM-DD",
            class: "w-100"
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_19, [
      _createVNode(_component_el_form_item, {
        prop: "phone1",
        rules: [
                {required: true, message:'Campo obligatorio', trigger:['blur', 'change']}
            ]
      }, {
        label: _withCtx(() => [
          _hoisted_20
        ]),
        default: _withCtx(() => [
          _createVNode(_component_el_input, {
            modelValue: __props.form.phone1,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((__props.form.phone1) = $event)),
            maxlength: "9"
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_21, [
      _createVNode(_component_el_form_item, {
        prop: "email1",
        rules: [
                {required: true, message:'Campo obligatorio', trigger:['blur', 'change']},
                {type: 'email', message: 'Emial inválido', trigger: ['blur', 'change']}
            ]
      }, {
        label: _withCtx(() => [
          _hoisted_22
        ]),
        default: _withCtx(() => [
          _createVNode(_component_el_input, {
            modelValue: __props.form.email1,
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((__props.form.email1) = $event)),
            maxlength: "100"
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      })
    ])
  ]))
}
}

})